/*
 * @Date: 2019-08-09 19:49:42
 * @LastEditors: hzgegenhasi@corp.netease.com
 * @LastEditTime: 2019-08-09 19:49:42
 * @Author: hzgegenhasi@corp.netease.com
 */
import { message } from 'antd';
import moment from 'moment';
import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import { Type } from './redux';

/**
 * 获取公告内容
 */

const getAnnouncement = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_ANNOUNCEMENT),
    switchMap(({ announceId }) =>
      fetch({
        url: '/mm-classroom/web/j/announcementRpcBean.getMocAnnouncementById.rpc',
        body: {
          announceId,
        },
      }),
    ),
    map(content => {
      return {
        type: Type.GET_ANNOUNCEMENT_SUCCESS,
        announcementContent: {
          ...content,
        },
      };
    }),
  );


export default [
  getAnnouncement
];
